export function DvdDisc() {
  return (
    <div className="media-disc absolute w-[95%] h-[95%] rounded-full flex items-center justify-center shadow-2xl top-[2.5%] z-0">
      <div className="media-disc-rotor absolute inset-0 rounded-full flex items-center justify-center">
        {/* Base disc — silver/blue DVD */}
        <div
          className="absolute inset-0 rounded-full"
          style={{
            background:
              "radial-gradient(circle at center, #c0c8d8 0%, #8090a8 25%, #a0b0c8 45%, #7888a0 65%, #90a0b8 85%, #b0c0d0 100%)",
          }}
        />
        {/* Data track rings */}
        <div
          className="absolute inset-[8%] rounded-full"
          style={{
            background:
              "repeating-radial-gradient(circle at center, transparent 0px, transparent 3px, rgba(100,140,200,0.12) 3.5px, transparent 4px)",
          }}
        />
        {/* Hub ring */}
        <div
          className="absolute w-[30%] h-[30%] rounded-full border border-slate-400/40"
          style={{
            background: "radial-gradient(circle at center, #e8edf5 0%, #c8d0e0 40%, #a0a8b8 100%)",
          }}
        />
        {/* Center hole */}
        <div
          className="absolute w-[8%] h-[8%] rounded-full bg-transparent"
          style={{ boxShadow: "inset 0 1px 3px rgba(0,0,0,0.5)" }}
        />
      </div>
      {/* Optical color and room highlights stay fixed as the DVD rotates. */}
      <div
        className="pointer-events-none absolute inset-0 rounded-full"
        style={{
          background:
            "conic-gradient(from 155deg at center, rgba(120,80,220,0.17), rgba(70,135,255,0.14) 65deg, rgba(40,210,190,0.12) 125deg, rgba(225,210,70,0.1) 190deg, rgba(220,95,90,0.12) 250deg, rgba(155,75,210,0.15) 315deg, rgba(120,80,220,0.17)), radial-gradient(ellipse 55% 38% at 34% 24%, rgba(255,255,255,0.3), transparent 58%)",
          maskImage: "radial-gradient(circle, transparent 0 9%, black 11% 98%, transparent 100%)",
          WebkitMaskImage:
            "radial-gradient(circle, transparent 0 9%, black 11% 98%, transparent 100%)",
        }}
      />
    </div>
  );
}
